@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $datepicker-host-display;
}

.datepicker {
  display: $datepicker-display;
  width: $datepicker-width;
  --air-dropdown-base-background: transparent;

  .datepicker * {
    box-sizing: $datepicker-box-sizing;
  }

  .datepicker-input {
    margin-bottom: $datepicker-input-margin-bottom;
    --air-input-min-width: #{$datepicker-input-width};
  }

  .datepicker {
    width: $datepicker-picker-width;
    height: $datepicker-picker-height;
    border: $datepicker-picker-border;
    border-radius: $datepicker-picker-border-radius;
    padding: $datepicker-picker-padding;
    background-color: $datepicker-picker-background-color;
    &-header {
      margin-bottom: $datepicker-picker-header-margin-bottom;
      .datepicker-controls {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        .button {
          display: flex;
          cursor: pointer;
          color: $datepicker-picker-controls-button-color;
          font-family: $datepicker-picker-controls-button-font-family;
          font-size: $datepicker-picker-controls-button-font-size;
          font-weight: $datepicker-picker-controls-button-font-weight;
          line-height: $datepicker-picker-controls-button-line-height;
          padding: 0;
          border: none;
          background-color: transparent;
          &.prev-btn,
          &.next-btn {
            padding: $datepicker-picker-controls-button-next-prev-padding;
            border-radius: $datepicker-picker-controls-button-next-prev-border-radius;
          }
          &.view-switch {
            border-radius: $datepicker-picker-controls-button-view-switch-border-radius;
            padding: $datepicker-picker-controls-button-view-switch-padding;
          }
          &:hover {
            background-color: $datepicker-picker-controls-button-hover-background-color;
          }
          &:focus {
            outline: none;
            box-shadow: 0 0 0 $datepicker-picker-controls-button-focus-outline-width
              $datepicker-picker-controls-button-focus-outline-color;
          }
        }
      }
    }
    &-main {
      .days-of-week {
        display: grid;
        gap: $datepicker-picker-days-of-week-gap;
        grid-template-columns: repeat(7, 1fr);
        justify-items: center;
        text-align: center;
        margin-bottom: $datepicker-picker-days-of-week-margin-bottom;
        .dow {
          color: $datepicker-picker-days-of-week-color;
          font-family: $datepicker-picker-days-of-week-font-family;
          font-size: $datepicker-picker-days-of-week-font-size;
          font-weight: $datepicker-picker-days-of-week-font-weight;
          line-height: $datepicker-picker-days-of-week-line-height;
          width: $datepicker-picker-days-of-week-width;
        }
      }
      .datepicker-grid {
        display: grid;
        gap: $datepicker-picker-grid-gap;
        grid-template-columns: repeat(7, 1fr);
        justify-items: center;
        text-align: center;
      }
      .datepicker-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: $datepicker-picker-cell-width;
        height: $datepicker-picker-cell-height;
        color: $datepicker-picker-cell-color;
        font-family: $datepicker-picker-cell-font-family;
        font-size: $datepicker-picker-cell-font-size;
        font-weight: $datepicker-picker-cell-font-weight;
        line-height: $datepicker-picker-cell-line-height;
        border-radius: $datepicker-picker-cell-border-radius;
        &.selected {
          color: $datepicker-picker-cell-selected-color;
          border: $datepicker-picker-cell-selected-border;
          &:before {
            position: absolute;
            content: '';
            opacity: 0.05;
            width: 100%;
            height: 100%;
            background-color: $datepicker-picker-cell-selected-background-color;
          }
        }
        &.today {
          border: $datepicker-picker-cell-today-border;
        }
        &.next,
        &.prev {
          color: $datepicker-picker-cell-next-prev-color;
        }
        &.disabled {
          color: $datepicker-picker-cell-disabled-color;
        }
        &:not(.selected).focused {
          box-shadow: 0 0 0 $datepicker-picker-cell-focus-outline-width
            $datepicker-picker-cell-focus-outline-color;
        }
        &:hover:not(.disabled) {
          cursor: pointer;
          background-color: $datepicker-picker-cell-hover-background-color;
        }
      }

      .months,
      .years,
      .decades {
        display: grid;
        gap: $datepicker-picker-grid-period-gap;
        grid-template-columns: repeat(4, 1fr);
        justify-items: center;
        text-align: center;
        .datepicker-cell {
          height: $datepicker-picker-cell-months-hover-height;
        }
      }
    }
  }
}

@media (max-width: $breakpoint-mobile) {
  .datepicker {
    width: $mobile-datepicker-width;

    .datepicker-input {
      width: $mobile-datepicker-width;
    }

    .datepicker {
      width: $mobile-datepicker-width;
      max-width: $mobile-datepicker-max-width;
    }
  }
}
